import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { CardArrivalDetail } from 'src/app/data/models/dto/arrival/card-arrival-detail';
import { GateArrivalsFilterDto } from 'src/app/data/models/dto/arrival/gate-arrivals-filter.dto';
import { GateGatewayService } from 'src/app/data/services/arrival/gate-gateway.service';
import { UserUtil } from 'src/app/data/utils/user.utils';
import { GateMonitoringFilterComponent } from 'src/app/ui/components/arrival/gate-monitoring-filter/gate-monitoring-filter.component';
import { buildReleaseChild } from '../../../../data/factory/arrival.factory';
import { Arrival } from '../../../../data/models/dto/arrival/arrival';
import {
  Child,
  GatesMonitorDto,
} from '../../../../data/models/dto/arrival/gates-monitor.dto';
import { PageDto } from '../../../../data/models/dto/arrival/page.dto';
import { ArrivalStatus } from '../../../../data/models/enum/arrival/arrival-status.enum';
import { Vehicle } from '../../../../data/models/enum/arrival/vehicle.enum';
import { GateService } from '../../../../data/services/arrival/gate.service';
import { GatesMonitoringService } from '../../../../data/services/arrival/gates-monitoring.service';
import { ArrivalDetailStatusComponent } from '../../../../ui/components/arrival/arrival-detail-status/arrival-detail-status.component';
import { CustomSnackbarService } from '../../../../ui/components/custom-snackbar/custom-snackbar-service';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss'],
})
export class MonitoringComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  arrivalMonitor: GatesMonitorDto[] = [];
  gateId: string = '';

  showHistory = false;

  currentFilter!: string;

  @ViewChild(GateMonitoringFilterComponent)
  child!: GateMonitoringFilterComponent;
  messagePage: string = '';

  constructor(
    private service: GatesMonitoringService,
    private gateService: GateService,
    private route: ActivatedRoute,
    private snackbar: CustomSnackbarService,
    private _bottomSheetArrivalDetail: MatBottomSheet,
    private gateGateway: GateGatewayService,
    private readonly userUtil: UserUtil
  ) {
    this.route.params.subscribe((params: Params) => {
      this.gateId = params['idGate'];
      this.gateGateway.subscribeGateChanges(this.gateId);
    });
  }

  ngOnInit(): void {
    this.filterByArrival(ArrivalStatus.GOING);
    this.listenGateChanges();
  }

  filterByArrival(filter: string) {
    this.arrivalMonitor = [];
    this.currentFilter = filter;
    this.showHistory = filter === 'HISTORY';
    if (!this.showHistory) {
      const params: GateArrivalsFilterDto =
        filter == 'AUTHORIZED'
          ? { hasAuthorization: true, currentDate: true }
          : {
              status: [
                filter,
                ...(filter == ArrivalStatus.GOING
                  ? [ArrivalStatus.UNPREDICTABLE]
                  : []),
              ],
              hasAuthorization: false,
              currentDate: true,
            };
      try {
        this.gateService
          .getArrivalsByIdAndFilter(this.gateId!, params)
          .toPromise()
          .then((response: PageDto<GatesMonitorDto>) => {
            if (response && response.data) {
              this.formatCard(response.data, filter);
            }
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    }
    this.customPage(filter);
  }

  formatCard(resp: any, filter: string) {
    this.arrivalMonitor = [];
    resp.forEach((e: GatesMonitorDto) => {
      if (filter != 'AUTHORIZED' || e.status != ArrivalStatus.RELEASED) {
        e.textForecast = this.arrivalForecastDescription(
          ArrivalStatus[e.status]
        );
        e.classRoomDescription = this.getClassRoomDescription(e.child);
        e.iconVehicle = this.iconVehicle(Vehicle[e.vehicle]);
        this.arrivalMonitor.push(e);
      }
    });
  }

  openStatusDetail(emit: CardArrivalDetail): void {
    if (emit) {
      this._bottomSheetArrivalDetail.open(ArrivalDetailStatusComponent, {
        data: emit,
      });
    }
  }

  releaseChild(idArrival: string) {
    const releaseChild = buildReleaseChild(this.userUtil.getUser());
    this.service
      .updateArrivalReleaseChildren(idArrival, releaseChild)
      .toPromise()
      .then(
        (resp: Arrival) => {
          console.log('child released');
          console.log(resp);
          this.snackbar.showNotification('O aluno foi liberado', 2000);
          this.removeReleasedChildFromList(idArrival);
        },
        (error: Arrival) => {
          console.log('error on release child');
          console.log(error);
        }
      );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.gateGateway.unSubscribeGateChanges(this.gateId);
  }

  arrivalForecastDescription(status: string): string {
    const description =
      status === ArrivalStatus.GOING
        ? 'Chegada em'
        : status === ArrivalStatus.UNPREDICTABLE
        ? 'Chegada em'
        : status === ArrivalStatus.RELEASED
        ? 'Criança liberada'
        : status === ArrivalStatus.ARRIVED
        ? 'Aguardando liberação'
        : status === ArrivalStatus.CANCELED
        ? 'Cancelado'
        : '';
    return description;
  }

  getClassRoomDescription(child: Child): string {
    return child.segment.name
      .concat(' - ')
      .concat(child.classRoom.name)
      .concat(' ')
      .concat(child.serie.name);
  }

  iconVehicle(vehicle: string): string {
    const icon =
      vehicle === Vehicle.FOOT
        ? 'assets/images/ic_directions_run_24px.svg'
        : vehicle === Vehicle.CAR
        ? 'assets/images/ic_directions_car_24px.svg'
        : vehicle === Vehicle.BICYCLE
        ? 'assets/images/ic_directions_bike_24px.svg'
        : 'assets/images/ic_directions_car_24px.svg';
    return icon;
  }

  removeReleasedChildFromList(idArrival: string) {
    this.arrivalMonitor.forEach((elem, index) => {
      if (elem.idArrival === idArrival) {
        this.arrivalMonitor.splice(index, 1);
      }
    });
  }

  private listenGateChanges() {
    this.gateGateway.listenDisconnections();
    this.subscription = this.gateGateway.getGateChanges().subscribe((item) => {
      this.filterByArrival(this.currentFilter);
      this.child.filtersType.forEach((elem) => {
        if (
          elem.filter == item.status &&
          item.isResponsable &&
          !elem.selected
        ) {
          elem.dirty = true;
        }
        if (
          elem.filter === 'AUTHORIZED' &&
          !item.isResponsable &&
          item.status !== ArrivalStatus.RELEASED &&
          !elem.selected
        ) {
          elem.dirty = true;
        }
      });
    });
  }

  customPage(filter: string) {
    switch (filter) {
      case 'GOING':
        this.messagePage = 'Nenhum responsável indicou que está a caminho';
        break;
      case 'AUTHORIZED':
        this.messagePage = 'Nenhuma pessoa com autorização está a caminho';
        break;
      case 'UNPREDICTABLE':
        this.messagePage = 'Nenhum imprevisto foi comunicado';
        break;
      case 'ARRIVED':
        this.messagePage = 'Nenhum responsável indicou que já chegou';
        break;
      default:
        this.messagePage = '';
    }
  }
}
